import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const CustomInput = styled.input`
  padding: 10px;
  background: #eaedf5;
  border: 1px solid #DDDEE8;
  border-radius: 50px;
  max-width: 600px;
  width: ${(props) => props.width || "100%"};
`;

const Label = styled.label`
  font-size: 14px;
  font-weight: 600;
`;

const TextInput = ({ label, type, placeholder, value, onChange, width }) => {
  return (
    <Container>
      <Label>{label}</Label>
      <CustomInput
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        width={width}
      />
    </Container>
  );
};

export default TextInput;
